import React from 'react';

let UnEvent =  React.createContext({
    unConfirmEventCnt: 0,
    historyAlarmCount: 0,
    showHistoryAlarm: false,
    setUnEvent: () => {}
});

export default UnEvent;
